const Strings = {
  REMOVE_NEWS: {
    SE: 'Ta bort nyhet',
    EN: 'Remove news'
  },
  REMOVE_NEWS_TEXT: {
    SE: 'Är du säker på att du vill ta bort denna nyheten?',
    EN: 'Are you sure that you want to remove this news?'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  REMOVE_COMMENT: {
    SE: 'Ta bort kommentar',
    EN: 'Remove comment'
  },
  REMOVE_COMMENT_TEXT: {
    SE: 'Är du säker på att du vill ta bort denna kommentaren?',
    EN: 'Are you sure that you want to remove this comment?'
  },
  EMPTY_COMMENT: {
    SE: 'Tom kommentar',
    EN: 'Empty comment'
  },
  EMPTY_COMMENT_TEXT: {
    SE: 'Du kan inte skicka tomma kommentarer.',
    EN: 'You can not send empty comments.'
  },
  NEW_POST: {
    SE: 'Ny nyhet',
    EN: 'New post'
  },
  SOMETHING_WENT_WRONG: {
    SE: 'Något gick fel',
    EN: 'Something went wrong'
  },
  SOMETHING_WENT_WRONG_TEXT: {
    SE: 'Något gick fel, försök igen senare.',
    EN: 'Something went wrong, try again later.'
  },
  MY_PAGE: {
    SE: 'Min sida',
    EN: 'My page'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/generalSettings/MyPage/strings.js